import { Col, DatePicker, Input, InputNumber, Row } from 'antd'
import { HelpMessage } from 'utils/constants'
import { Moment } from 'moment'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { LabeledValueType } from 'components/CIMSSelect/types'
import { useSubmittalTrackerContext } from '../../../../../../../SubmittalTrackerContext'
import { SharePointRegexValidation } from '@cims-online/shared'

const DetailsBody: React.FC = () => {
  const help = HelpMessage.CAS.SubmittalTracker
  const { invalidChars, whitespace } = SharePointRegexValidation
  const {
    allPackageNumbers,
    selectOptions: { typeOptions, subtypeOptions },
  } = useSubmittalTrackerContext()

  return (
    <>
      <Row gutter={30}>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="packageNumber"
            label="Package Number"
            requiredMessage="Please enter a package number"
            invalid={[
              {
                testPattern: invalidChars.regex,
                message: invalidChars.message,
              },
              {
                testPattern: whitespace.regex,
                message: whitespace.message,
              },
            ]}
            customValidator={{
              validator: (packageNumber) =>
                !allPackageNumbers.includes(packageNumber),
              message: 'Package Number already in use',
            }}
            validateFirst="parallel"
            help={help.PackageNumber}
          >
            <Input allowClear />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="packageName"
            label="Package Name"
            requiredMessage="Please enter a package name"
            invalid={[
              {
                testPattern: invalidChars.regex,
                message: invalidChars.message,
              },
              {
                testPattern: whitespace.regex,
                message: whitespace.message,
              },
            ]}
            validateFirst="parallel"
            help={help.PackageName}
          >
            <Input allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="typeId"
            label="Type"
            requiredMessage="Please select a type"
            help={help.Type}
          >
            <CIMSSelect options={typeOptions} />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12}>
          <CIMSFormItem name="subtypeId" label="Subtype" help={help.Subtype}>
            <CIMSSelect options={subtypeOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="quantity"
            label="Quantity"
            requiredMessage="Please enter a quantity"
            help={help.Quantity}
          >
            <InputNumber style={{ width: '100%' }} />
          </CIMSFormItem>
        </Col>
        <Col xs={24} xl={12}>
          <CIMSFormItem
            name="units"
            label="Units"
            requiredMessage="Please enter units"
            help={help.Units}
          >
            <Input />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <CIMSFormItem
          name="requestedReviewDate"
          label="Requested Review Date"
          requiredMessage="Please enter a requested review date"
          help={help.RequestedReviewDate}
        >
          <DatePicker allowClear />
        </CIMSFormItem>
      </Row>
    </>
  )
}

export default DetailsBody

export interface DetailsBodyValues {
  packageNumber: string
  packageName: string
  typeId: LabeledValueType
  subtypeId: LabeledValueType
  quantity: number
  units: string
  requestedReviewDate: Moment
}
